<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6675 5.66674C13.6675 5.66674 13.6679 1 10.5568 1C7.44563 1 7.44559 5.66674 7.44559 5.66674H13.6675Z"
      fill="currentColor"
    />
    <path
      d="M18.3345 16.5554C18.3345 16.5554 23.0013 16.5557 23.0013 13.4446C23.0013 10.3335 18.3345 10.3335 18.3345 10.3335L18.3345 16.5554Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 7.66686C2 6.5623 2.89543 5.66687 4 5.66687H16.3336C17.4382 5.66687 18.3336 6.5623 18.3336 7.66687V20.0005C18.3336 21.105 17.4382 22.0005 16.3336 22.0005H4C2.89543 22.0005 2 21.105 2 20.0005V16.5555C2.1028 16.5551 6.66498 16.5208 6.66498 13.4447C6.66498 10.3687 2.10279 10.334 2 10.3336V7.66686ZM10.5556 17.3335C13.667 17.3335 13.6666 22.0002 13.6666 22.0002H7.44427C7.44427 22.0002 7.4443 17.3335 10.5556 17.3335Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default { name: 'Puzzle' };
</script>

<style scoped lang="scss" type="text/scss">

</style>
